var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-102 grid"
  }, [_c('div', {
    staticClass: "div-block-147"
  }, [_c('div', {
    staticClass: "overlfowXauto MGbottom20px"
  }, [_c('div', {
    staticClass: "mortgage-result-broker signed"
  }, [_c('div', {
    staticClass: "mortgage-parameters signed"
  }, [_c('img', {
    staticClass: "bank-logo",
    attrs: {
      "src": _vm.application.bank.logo_square,
      "loading": "lazy",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "bold wrap100px"
  }, [_c('span', {
    staticClass: "light"
  }, [_vm._v("suma")]), _c('br'), _vm._v(_vm._s(_vm._f("dotTheAmount")(_vm.getTotalAmountBasedOnCorrection())) + " EUR ")]), _c('div', {
    staticClass: "bold wrap50px"
  }, [_c('span', {
    staticClass: "light"
  }, [_vm._v("sadzba")]), _c('br'), _vm._v(" " + _vm._s(_vm._f("toFloor")(_vm.application.sadzba_schvalena, 2))), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("%")])]), _c('div', {
    staticClass: "bold wrap100px"
  }, [_c('span', {
    staticClass: "light"
  }, [_vm._v("splátka")]), _c('br'), _vm._v(_vm._s(_vm._f("dotTheAmount")(_vm.application.splatka)) + " "), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("EUR")])]), _c('div', {
    staticClass: "bold wrap50px"
  }, [_c('span', {
    staticClass: "light"
  }, [_vm._v("poplatok")]), _c('br'), _vm._v(_vm._s(_vm._f("dotTheAmount")(_vm.application.poplatok_za_poskytnutie)) + " "), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("EUR")])]), _c('div', {
    staticClass: "bold wrap50px"
  }, [_c('span', {
    staticClass: "light"
  }, [_vm._v("splatnosť")]), _c('br'), _vm._v(_vm._s(_vm.application.splatnost) + " "), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("R")])]), _c('div', {
    staticClass: "bold wrap50px"
  }, [_vm._v("FIX " + _vm._s(_vm.application.fix))])])])]), _vm._m(0), _c('div', {
    staticClass: "div-block-153 upload-grid upload-grid--contracts"
  }, _vm._l(_vm.cloudGetter.missingFiles, function (missingFile, index) {
    return _vm.firstStepFiles.includes(missingFile.code) ? _c('document-cloud-handler', {
      key: index + 'cldmis',
      attrs: {
        "title": _vm.getRequiredFileLabel(missingFile),
        "type": missingFile.id,
        "uploaded": missingFile.uploaded,
        "class-cst": 'upload-item-broker-custom',
        "cloud-meta": _vm.cloudGetter.cloudMeta,
        "rules": ['priority'],
        "show-files": false,
        "text-button": "",
        "leading-text": ""
      }
    }) : _vm._e();
  }), 1), _vm.firstStepPickedFilesGetter.length ? _c('div', {
    staticClass: "uploaded-document-list",
    attrs: {
      "aria-label": "Nahraná úverová dokumentácia"
    }
  }, _vm._l(_vm.firstStepPickedFilesGetter, function (file, index) {
    return _c('div', {
      key: file.id || "first-step-file-".concat(index),
      staticClass: "uploaded-document-row"
    }, [_c('div', {
      staticClass: "uploaded-document-status",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("✓")]), _c('div', {
      staticClass: "uploaded-document-copy"
    }, [_c('div', {
      staticClass: "uploaded-document-type"
    }, [_vm._v(_vm._s(_vm.getFileTypeLabel(file)))]), _c('div', {
      staticClass: "small fileName"
    }, [_vm._v(_vm._s(file.name))])]), _c('div', {
      staticClass: "uploaded-document-badge"
    }, [_vm._v("nahrané")])]);
  }), 0) : _vm._e(), _vm.clientNeedsRecordMissingFile && _vm.mortgageCloudGetter ? _c('section', {
    staticClass: "client-needs-record-section"
  }, [_c('div', {
    staticClass: "client-needs-record-heading"
  }, [_c('span', {
    staticClass: "client-needs-record-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "clipboard",
      "size": 22
    }
  })], 1), _vm._m(1)]), _c('div', {
    staticClass: "client-needs-record-upload"
  }, [_c('document-cloud-handler', {
    attrs: {
      "title": _vm.getRequiredFileLabel(_vm.clientNeedsRecordMissingFile),
      "type": _vm.clientNeedsRecordMissingFile.id,
      "uploaded": _vm.clientNeedsRecordMissingFile.uploaded,
      "class-cst": 'upload-item-broker-custom upload-item-broker-custom--record',
      "cloud-meta": _vm.mortgageCloudGetter.cloudMeta,
      "rules": ['priority'],
      "show-files": false,
      "text-button": "",
      "leading-text": "nahrať záznam"
    }
  })], 1), _vm.clientNeedsRecordPickedFilesGetter.length ? _c('div', {
    staticClass: "uploaded-document-list uploaded-document-list--record",
    attrs: {
      "aria-label": "Nahraný záznam o sprostredkovaní"
    }
  }, _vm._l(_vm.clientNeedsRecordPickedFilesGetter, function (file, index) {
    return _c('div', {
      key: file.id || "client-needs-record-".concat(index),
      staticClass: "uploaded-document-row"
    }, [_c('div', {
      staticClass: "uploaded-document-status",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("✓")]), _c('div', {
      staticClass: "uploaded-document-copy"
    }, [_c('div', {
      staticClass: "uploaded-document-type"
    }, [_vm._v("Záznam o sprostredkovaní")]), _c('div', {
      staticClass: "small fileName"
    }, [_vm._v(_vm._s(file.name))])]), _c('div', {
      staticClass: "uploaded-document-badge"
    }, [_vm._v("nahrané")])]);
  }), 0) : _vm._e()]) : _vm._e(), _vm._m(2), _c('div', {
    staticClass: "div-block-148"
  }, [_c('div', {
    staticClass: "dropdown-input-custom contrast rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'credit_card_banka',
      "init-value": _vm.mortgage.cerpanie_na_zapis_zalozneho_prava,
      "options": _vm.secondStepChoices,
      "normal": ""
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event);
      }
    }
  })], 1)])]), _c('div', {
    staticClass: "div-block-147 MGtop20px"
  }, [_vm._m(3), _c('div', {
    staticClass: "div-block-153 upload-grid"
  }, _vm._l(_vm.cloudGetter.missingFiles, function (missingFile, index) {
    return _vm.thirdStepFiles.includes(missingFile.code) ? _c('document-cloud-handler', {
      key: index + 'cldmis',
      attrs: {
        "title": missingFile.name,
        "type": missingFile.id,
        "uploaded": missingFile.uploaded,
        "class-cst": 'upload-item-broker-custom',
        "cloud-meta": _vm.cloudGetter.cloudMeta,
        "rules": ['priority'],
        "show-files": false,
        "text-button": "",
        "leading-text": ""
      }
    }) : _vm._e();
  }), 1), _vm.thirdStepPickedFilesGetter.length ? _c('div', {
    staticClass: "uploaded-document-list",
    attrs: {
      "aria-label": "Nahrané podklady pre čerpanie"
    }
  }, _vm._l(_vm.thirdStepPickedFilesGetter, function (file, index) {
    return _c('div', {
      key: file.id || "third-step-file-".concat(index),
      staticClass: "uploaded-document-row"
    }, [_c('div', {
      staticClass: "uploaded-document-status",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("✓")]), _c('div', {
      staticClass: "uploaded-document-copy"
    }, [_c('div', {
      staticClass: "uploaded-document-type"
    }, [_vm._v(_vm._s(_vm.getFileTypeLabel(file)))]), _c('div', {
      staticClass: "small fileName"
    }, [_vm._v(_vm._s(file.name))])]), _c('div', {
      staticClass: "uploaded-document-badge"
    }, [_vm._v("nahrané")])]);
  }), 0) : _vm._e(), _c('div', {
    staticClass: "div-block-153 MGtop20px"
  }, [_vm.zipDownloading ? _c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  }) : _c('button', {
    staticClass: "download-all-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.download
    }
  }, [_c('span', {
    staticClass: "download-all-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "download",
      "size": 19
    }
  })], 1), _c('span', [_vm._v("Stiahnuť všetky podklady")])])], 1), _vm._m(4), _c('div', {
    staticClass: "div-block-153"
  }, [_c('div', {
    staticClass: "input-group drawdown-date-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.nacerpana,
      expression: "form.nacerpana"
    }],
    staticClass: "text-input w-input date-input contrast",
    attrs: {
      "name": "dateOfBirth",
      "type": "date",
      "maxlength": "256"
    },
    domProps: {
      "value": _vm.form.nacerpana
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "nacerpana", $event.target.value);
      }
    }
  }), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.paymentDay,
      expression: "form.paymentDay",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input drawdown-payment-day contrast",
    attrs: {
      "aria-label": "Deň mesačnej splátky",
      "required": ""
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val);
        });
        _vm.$set(_vm.form, "paymentDay", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Deň splátky")]), _vm._l(_vm.paymentDays, function (day) {
    return _c('option', {
      key: day,
      domProps: {
        "value": day
      }
    }, [_vm._v(" Splátka " + _vm._s(day) + ". deň ")]);
  })], 2), _c('button', {
    staticClass: "drawdown-confirm-button",
    attrs: {
      "disabled": !_vm.canSubmitDrawdown || _vm.drawdownSaving
    },
    on: {
      "click": _vm.confirmDrawMortgage
    }
  }, [_vm.drawdownSaving ? _c('span', [_vm._v("ukladám...")]) : _c('span', [_vm._v(_vm._s(_vm.mortgage && _vm.mortgage.nacerpana ? "Uložiť dátum" : "Potvrdiť načerpanie"))])])])])]), _vm._m(5), _vm.showDrawdownSuccess ? _c('div', {
    staticClass: "drawdown-success-overlay"
  }, [_c('div', {
    staticClass: "drawdown-confetti",
    attrs: {
      "aria-hidden": "true"
    }
  }, _vm._l(18, function (index) {
    return _c('span', {
      key: index,
      style: _vm.confettiStyle(index)
    });
  }), 0), _c('div', {
    staticClass: "drawdown-success-card"
  }, [_c('div', {
    staticClass: "drawdown-success-badge"
  }, [_vm._v("✓")]), _c('div', {
    staticClass: "drawdown-success-title"
  }, [_vm._v("Hypotéka načerpaná")]), _c('div', {
    staticClass: "drawdown-success-text"
  }, [_vm._v(" Obchod je úspešne dokončený a hypotéka bola presunutá do servisu. ")]), _c('button', {
    staticClass: "drawdown-success-button",
    on: {
      "click": function click($event) {
        _vm.showDrawdownSuccess = false;
      }
    }
  }, [_vm._v(" Hotovo ")])])]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-148 topalign"
  }, [_c('div', {
    staticClass: "div-block-110 primary"
  }, [_vm._v("1")]), _c('div', [_vm._v("Nahrajte úverovú dokumentáciu")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "client-needs-record-title"
  }, [_vm._v("Záznam o sprostredkovaní")]), _c('div', {
    staticClass: "client-needs-record-description"
  }, [_vm._v(" Podpísaný záznam o potrebách klienta sa uloží do cloudu celej hypotéky. ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-148 topalign MGtop20px"
  }, [_c('div', {
    staticClass: "div-block-110 primary"
  }, [_vm._v("2")]), _c('div', [_vm._v("Vyberte model čerpania")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-148 topalign"
  }, [_c('div', {
    staticClass: "div-block-110 primary"
  }, [_vm._v("3")]), _c('div', [_vm._v("Nahrajte podklady pre čerpanie")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-148 topalign MGtop20px"
  }, [_c('div', {
    staticClass: "div-block-110 primary"
  }, [_vm._v("4")]), _c('div', [_vm._v("Hypotéka bola načerpaná dňa")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-small light MGtop20px"
  }, [_vm._v("V prípade tohto kroku "), _c('b', [_vm._v("nie je potrebné nahrať skeny")]), _vm._v(" všetkych podkladov na čerpanie, táto funkcia slúži skôr ako manuál k čerpaniu s možnosťou uchovať si úverovú zmluvu a ostatné dokumenty v archíve pre prípad do budúcna.")]);

}]

export { render, staticRenderFns }